import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function CandidateSalary(description) {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
  <div>
    {description.description === t("Conditions - Expected Salary") ? (
      <fieldset>
        <legend>{t("Expected Salary")}</legend>
        <div className="row">
          <div className="col">
            <input
              className="form-control"
              type="number"
              value={searchObject.lowerBoundSalary || ""}
              name="lowerBoundSalary"
              onChange={onChange}
              min="0"
            />
            <div className="form-text">min.</div>
          </div>{" "}
          <div className="col">
            <input
              className="form-control"
              type="number"
              value={searchObject.upperBoundSalary || ""}
              name="upperBoundSalary"
              onChange={onChange}
              min="0"
            />
            <div className="form-text">max.</div>
          </div>
        </div>
      </fieldset>
      ) : (
      <fieldset>
        <legend>{t("Current Salary")}</legend>
        <div className="row">
          <div className="col">
            <input
              className="form-control"
              type="number"
              value={searchObject.lowerBoundCurrentSalary || ""}
              name="lowerBoundCurrentSalary"
              onChange={onChange}
              min="0"
            />
            <div className="form-text">min.</div>
          </div>{" "}
          <div className="col">
            <input
              className="form-control"
              type="number"
              value={searchObject.upperBoundCurrentSalary || ""}
              name="upperBoundCurrentSalary"
              onChange={onChange}
              min="0"
            />
            <div className="form-text">max.</div>
          </div>
        </div>
      </fieldset>
    )}
  </div>
  );
}
